export default (state, id, itemState) => ({
  ...state,
  items: [
    ...state.items.map(item => (item.id === id ? { ...item, itemState } : item))
  ]
});
